module.exports = __webpack_public_path__ + "static/img/1tgimg.28c610e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1tgimg.jpg
// module id = kCcz
// module chunks = 2